<template>
    <div class="related-positions">
        <div class="uk-flex uk-flex-column uk-flex-row@m uk-width-1-1 uk-flex-between uk-flex-top uk-margin-xlarge-top uk-margin-bottom uk-margin-medium-bottom@m">
            <h2 class="uk-h3 uk-margin-small-bottom uk-margin-remove@m">{{ sectionTitle }}</h2>
            <a :href="seeAllLink" class="uk-button uk-button-primary">{{ $t('message.see_all_positions') }}</a>
        </div>
        <div class="uk-grid uk-grid-medium uk-child-width-1-2@s" uk-grid>
            <div v-for="job in relatedJobs" :key="job.JobRequisitionId">
                <job-item :job="job" :dept-name="departmentName"></job-item>
            </div>
        </div>
    </div>
</template>

<script>
import JobItem from './JobItem.vue';

export default {
    name: 'RelatedPositions',
    components: {
        'job-item': JobItem,
    },
    props: {
        departmentId: {
            type: [String, Number],
            required: true,
        },
        departmentName: {
            type: String,
            required: true,
        },
        currentJobId: {
            type: [String, Number],
            required: true,
        },
    },
    computed: {
        relatedJobs() {
            if (!window.careers_data || !window.careers_data.job_data || !window.careers_data.job_data.jobs) {
                return [];
            }
            const allJobs = window.careers_data.job_data.jobs;
            const currentJobIdStr = String(this.currentJobId);

            // Find the current job in the master list to get its true department ID
            const currentJob = allJobs.find(job => String(job.JobRequisitionId) === currentJobIdStr);

            if (!currentJob || !Array.isArray(currentJob.departments) || currentJob.departments.length === 0) {
                return []; // Cannot determine department, so no related jobs
            }

            const trueDepartmentId = currentJob.departments[0];

            const filteredJobs = allJobs.filter(job => {
                const jobRequisitionIdStr = String(job.JobRequisitionId);
                const isCorrectDepartment = Array.isArray(job.departments) && job.departments.includes(trueDepartmentId);
                const isNotCurrentJob = jobRequisitionIdStr !== currentJobIdStr;
                return isCorrectDepartment && isNotCurrentJob;
            });

            // Shuffle and pick 2
            const shuffled = filteredJobs.sort(() => 0.5 - Math.random());
            return shuffled.slice(0, 2);
        },
        sectionTitle() {
            return this.$t('message.more_positions', { department: this.departmentName });
        },
        seeAllLink() {
            const locale = window.careers_data.locale;
            const currentPath = window.location.pathname;
            let openPositionsPath = '/careers/open-positions';

            if (locale !== 'en') {
                if (currentPath.startsWith('/jp-refresh')) {
                    openPositionsPath = '/jp-refresh/careers/open-positions';
                } else {
                    openPositionsPath = '/jp/careers/open-positions';
                }
            }
            return `${window.location.origin}${openPositionsPath}?department=${this.departmentId}`;
        }
    },
     created() {
        // Add translations for dynamic texts
        if (this.$i18n.messages.default) {
            this.$i18n.mergeLocaleMessage('default', {
                message: {
                    more_positions: 'More {department} Positions',
                    see_all_positions: 'See all positions'
                }
            });
        }
    }
};
</script> 
